"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const StyledAddButton = (0, material_1.styled)(material_1.IconButton)((theme) => ({
    root: {
        color: theme.palette?.white,
        // @ts-ignore TODO: Figure out typings for themes (are themes even something we can/should share?)
        backgroundColor: theme?.palette?.text?.link,
        "&:hover": {
            // todo [js] replace with signet colors here
            backgroundColor: "#570A00", // signet color cta-default
        },
    },
}));
const StyledBox = (0, material_1.styled)(material_1.Box)(({ theme }) => ({
    width: 60,
    cursor: "pointer",
    borderLeft: `1px solid ${theme.palette.divider}`,
}));
const StyledButton = (0, material_1.styled)(material_1.Button)(({ theme }) => ({
    // @ts-ignore TODO: Figure out typings for themes (are themes even something we can/should share?)
    color: theme?.palette?.primary?.brown,
}));
const AddFilterButton = ({ onClick, disabled, }) => (react_1.default.createElement(StyledBox, { "data-testid": "AddFilterButton_root", component: "div", display: "flex", sx: disabled
        ? {
            cursor: "default",
        }
        : {}, flexWrap: "wrap", justifyContent: "center", alignItems: "center", alignContent: "center", onClick: (event) => {
        if (!disabled) {
            onClick(event);
        }
    } },
    react_1.default.createElement(StyledAddButton, { "aria-label": "add", size: "small", disabled: disabled, "data-testid": "add" },
        react_1.default.createElement(Add_1.default, null)),
    react_1.default.createElement(StyledButton, { disabled: disabled }, "Add")));
exports.default = AddFilterButton;
